export default "__VITE_ASSET__Ch177aNd__"